import DiscoTableSortDropdown, {
  DiscoTableSortDirection,
  DiscoTableSortOption,
  DiscoTableToolbarStateWithSort,
} from "@disco-ui/table/header/search/DiscoTableSortDropdown"
import { ArrayUtils } from "@utils/array/arrayUtils"
import { TestIDProps } from "@utils/typeUtils"

export interface AdminMembersReportProductsTableSortDropdownProps extends TestIDProps {
  sortState: DiscoTableToolbarStateWithSort
  setSortState: (state: DiscoTableToolbarStateWithSort) => void
  additionalSortOptions?: DiscoTableSortOption[]
  productType: "course" | "pathway"
}

function AdminMembersReportProductsTableSortDropdown({
  testid = "AdminMembersReportProductsTableSortDropdown",
  sortState,
  setSortState,
  productType,
}: AdminMembersReportProductsTableSortDropdownProps) {
  const SORT_OPTIONS: DiscoTableSortOption[] = [
    {
      value: "join_date",
      title: "Join Date",
      context: {
        order: { field: "join_date" },
      },
    },
    ...ArrayUtils.spreadIf(
      {
        value: "event_attendance",
        title: "Event Attendance",
        context: {
          order: { field: "event_attendance" },
        },
      },
      productType === "course"
    ),
    {
      value: "engagement_score",
      title: "Engagement Score",
      context: {
        order: { field: "engagement_score" },
      },
    },
    {
      value: "last_active",
      title: "Last Active",
      context: {
        order: { field: "last_active" },
      },
    },
    {
      value: "time_spent",
      title: "Time Spent",
      context: {
        order: { field: "time_spent" },
      },
    },
  ]

  return (
    <DiscoTableSortDropdown
      testid={`${testid}.sort-dropdown`}
      options={SORT_OPTIONS}
      onOptionSelect={handleSortSelect}
      toolbarState={sortState}
    />
  )

  function handleSortSelect(
    sortOption: DiscoTableSortOption,
    direction: DiscoTableSortDirection
  ) {
    setSortState({
      search: sortState.search,
      sort: {
        id: sortOption.value,
        order: sortOption.context!.order,
        title: sortOption.title,
      },
      direction,
    })
  }
}

export default AdminMembersReportProductsTableSortDropdown
